import { render, staticRenderFns } from "./AllNotes.vue?vue&type=template&id=0f330fcc"
import script from "./AllNotes.vue?vue&type=script&lang=js"
export * from "./AllNotes.vue?vue&type=script&lang=js"
import style0 from "./AllNotes.vue?vue&type=style&index=0&id=0f330fcc&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports